export default "__VITE_ASSET__Crzzteib__"